import { __decorate, __param } from 'tslib';
import { ElementRef, Inject, Input, HostBinding, Component, forwardRef, ChangeDetectionStrategy, NgModule } from '@angular/core';
import { typedFromEvent, isNativeFocused, TuiFocusVisibleService, tuiDefaultProp, TUI_FOCUSABLE_ITEM_ACCESSOR, TuiDestroyService } from '@taiga-ui/cdk';
import { MODE_PROVIDER } from '@taiga-ui/core/providers';
import { TUI_MODE } from '@taiga-ui/core/tokens';
import { merge, Observable } from 'rxjs';
import { mapTo } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { TuiSvgModule } from '@taiga-ui/core/components/svg';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@taiga-ui/core/components/svg';
import * as ɵngcc3 from 'rxjs';
import * as ɵngcc4 from '@taiga-ui/cdk';

const _c0 = ["tuiLink", ""];
function TuiLinkComponent_tui_svg_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "tui-svg", 3);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("src", ctx_r0.icon || "");
} }
function TuiLinkComponent_tui_svg_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "tui-svg", 4);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("src", ctx_r1.icon || "");
} }
const _c1 = ["*"];
var TuiLinkComponent_1;
// @bad TODO: Think about extending Interactive
let TuiLinkComponent = TuiLinkComponent_1 = class TuiLinkComponent {
    constructor(elementRef, mode$, focusVisible$) {
        this.elementRef = elementRef;
        this.mode$ = mode$;
        this.pseudo = false;
        // TODO: Remove `null` in 3.0
        this.icon = null;
        this.iconAlign = 'right';
        this.iconRotated = false;
        this.mode = null;
        this.focusVisible = false;
        this.focusedChange = merge(typedFromEvent(this.elementRef.nativeElement, 'focusin').pipe(mapTo(true)), typedFromEvent(this.elementRef.nativeElement, 'focusout').pipe(mapTo(false)));
        focusVisible$.subscribe(visible => {
            this.focusVisible = visible;
        });
    }
    get nativeFocusableElement() {
        return this.elementRef.nativeElement;
    }
    get focused() {
        return isNativeFocused(this.nativeFocusableElement);
    }
    get hasIcon() {
        return this.icon !== null;
    }
    get iconAlignLeft() {
        return this.hasIcon && this.iconAlign === 'left';
    }
    get iconAlignRight() {
        return this.hasIcon && this.iconAlign === 'right';
    }
};
TuiLinkComponent.ɵfac = function TuiLinkComponent_Factory(t) { return new (t || TuiLinkComponent)(ɵngcc0.ɵɵdirectiveInject(ElementRef), ɵngcc0.ɵɵdirectiveInject(TUI_MODE), ɵngcc0.ɵɵdirectiveInject(TuiFocusVisibleService)); };
TuiLinkComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TuiLinkComponent, selectors: [["a", "tuiLink", ""], ["button", "tuiLink", ""]], hostVars: 7, hostBindings: function TuiLinkComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("$.data-mode.attr", function TuiLinkComponent___data_mode_attr_HostBindingHandler() { return ctx.mode$; });
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("data-host-mode", ctx.mode);
        ɵngcc0.ɵɵclassProp("_pseudo", ctx.pseudo)("_icon-rotated", ctx.iconRotated)("_focus-visible", ctx.focusVisible);
    } }, inputs: { pseudo: "pseudo", icon: "icon", iconAlign: "iconAlign", iconRotated: "iconRotated", mode: "mode" }, exportAs: ["tuiLink"], features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: TUI_FOCUSABLE_ITEM_ACCESSOR,
                useExisting: forwardRef(() => TuiLinkComponent_1)
            },
            TuiFocusVisibleService,
            TuiDestroyService,
            MODE_PROVIDER,
        ])], attrs: _c0, ngContentSelectors: _c1, decls: 4, vars: 2, consts: [["class", "t-icon t-icon_left", 3, "src", 4, "ngIf"], [1, "t-content"], ["class", "t-icon t-icon_right", 3, "src", 4, "ngIf"], [1, "t-icon", "t-icon_left", 3, "src"], [1, "t-icon", "t-icon_right", 3, "src"]], template: function TuiLinkComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, TuiLinkComponent_tui_svg_0_Template, 1, 1, "tui-svg", 0);
        ɵngcc0.ɵɵelementStart(1, "span", 1);
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(3, TuiLinkComponent_tui_svg_3_Template, 1, 1, "tui-svg", 2);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.iconAlignLeft);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.iconAlignRight);
    } }, directives: [ɵngcc1.NgIf, ɵngcc2.TuiSvgComponent], styles: ["[_nghost-%COMP%]{-webkit-appearance:none;-moz-appearance:none;appearance:none;padding:0;border:0;background:0 0;font-size:inherit;line-height:inherit;transition-property:color;transition-duration:var(--tui-duration,300ms);transition-timing-function:ease-in-out;color:var(--tui-link);text-decoration:none;text-align:left;text-transform:inherit;font-weight:inherit;cursor:pointer;outline:0}[_nghost-%COMP%]:hover{color:var(--tui-link-hover)}[_nghost-%COMP%]:disabled{opacity:var(--tui-disabled-opacity);cursor:default}[data-mode=onLight][_nghost-%COMP%]{color:var(--tui-text-02)}[data-mode=onLight]._active[_nghost-%COMP%], [data-mode=onLight][_nghost-%COMP%]:hover{color:var(--tui-text-01)}[data-mode=onLight]._pseudo[_nghost-%COMP%]{color:var(--tui-text-01)}[data-mode=onLight]._pseudo._active[_nghost-%COMP%], [data-mode=onLight]._pseudo[_nghost-%COMP%]:hover{color:var(--tui-text-03)}[data-mode=onLight][data-host-mode=negative][_nghost-%COMP%]{color:var(--tui-negative-night)}[data-mode=onLight][data-host-mode=negative]._active[_nghost-%COMP%], [data-mode=onLight][data-host-mode=negative][_nghost-%COMP%]:active, [data-mode=onLight][data-host-mode=negative][_nghost-%COMP%]:hover{color:var(--tui-negative-night-hover)}[data-mode=onDark][_nghost-%COMP%]{color:var(--tui-text-03-night)}[data-mode=onDark]._active[_nghost-%COMP%], [data-mode=onDark][_nghost-%COMP%]:active, [data-mode=onDark][_nghost-%COMP%]:hover{color:var(--tui-text-01-night)}[data-mode=onDark]._pseudo[_nghost-%COMP%]{color:var(--tui-text-01-night)}[data-mode=onDark]._pseudo._active[_nghost-%COMP%], [data-mode=onDark]._pseudo[_nghost-%COMP%]:active, [data-mode=onDark]._pseudo[_nghost-%COMP%]:hover{color:var(--tui-text-03-night)}[data-mode=onDark][data-host-mode=positive][_nghost-%COMP%]{color:var(--tui-positive-night)}[data-mode=onDark][data-host-mode=positive]._active[_nghost-%COMP%], [data-mode=onDark][data-host-mode=positive][_nghost-%COMP%]:active, [data-mode=onDark][data-host-mode=positive][_nghost-%COMP%]:hover{color:var(--tui-positive-night-hover)}[data-host-mode=negative][_nghost-%COMP%]{color:var(--tui-negative)}[data-host-mode=negative][_nghost-%COMP%]:hover{color:var(--tui-negative-hover)}[data-host-mode=positive][_nghost-%COMP%]{color:var(--tui-positive)}[data-host-mode=positive][_nghost-%COMP%]:hover{color:var(--tui-positive-hover)}.t-content[_ngcontent-%COMP%]{display:inline-block}._focus-visible[_nghost-%COMP%]   .t-content[_ngcontent-%COMP%]{background:var(--tui-selection)}[data-mode=onLight]._focus-visible[_nghost-%COMP%]   .t-content[_ngcontent-%COMP%]{background:var(--tui-clear);color:var(--tui-text-01)}[data-mode=onDark]._focus-visible[_nghost-%COMP%]   .t-content[_ngcontent-%COMP%]{background:var(--tui-clear-inverse);color:var(--tui-text-01-night)}[data-host-mode=positive]._focus-visible[_nghost-%COMP%]   .t-content[_ngcontent-%COMP%]{background:var(--tui-success-bg)}[data-host-mode=negative]._focus-visible[_nghost-%COMP%]   .t-content[_ngcontent-%COMP%]{background:var(--tui-error-bg)}._pseudo[_nghost-%COMP%]   .t-content[_ngcontent-%COMP%]{padding-bottom:.15em;-webkit-text-decoration:underline dashed;text-decoration:underline dashed;text-underline-offset:.2em;text-decoration-thickness:.7px}.t-icon[_ngcontent-%COMP%]{transition-property:transform;transition-duration:var(--tui-duration,300ms);transition-timing-function:ease-in-out;margin-top:-.125rem;opacity:.8}.t-icon_left[_ngcontent-%COMP%]{margin-right:.25rem}.t-icon_right[_ngcontent-%COMP%]{margin-left:.25rem}[_nghost-%COMP%]:hover   .t-icon[_ngcontent-%COMP%]{opacity:1}._icon-rotated[_nghost-%COMP%]   .t-icon[_ngcontent-%COMP%]{transform:rotate(180deg)}"], changeDetection: 0 });
TuiLinkComponent.ctorParameters = () => [
    { type: ElementRef, decorators: [{ type: Inject, args: [ElementRef,] }] },
    { type: Observable, decorators: [{ type: Inject, args: [TUI_MODE,] }] },
    { type: TuiFocusVisibleService, decorators: [{ type: Inject, args: [TuiFocusVisibleService,] }] }
];
__decorate([
    Input(),
    HostBinding('class._pseudo'),
    tuiDefaultProp()
], TuiLinkComponent.prototype, "pseudo", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiLinkComponent.prototype, "icon", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiLinkComponent.prototype, "iconAlign", void 0);
__decorate([
    Input(),
    HostBinding('class._icon-rotated'),
    tuiDefaultProp()
], TuiLinkComponent.prototype, "iconRotated", void 0);
__decorate([
    Input(),
    HostBinding('attr.data-host-mode'),
    tuiDefaultProp()
], TuiLinkComponent.prototype, "mode", void 0);
__decorate([
    HostBinding('class._focus-visible')
], TuiLinkComponent.prototype, "focusVisible", void 0);
TuiLinkComponent = TuiLinkComponent_1 = __decorate([ __param(0, Inject(ElementRef)),
    __param(1, Inject(TUI_MODE)),
    __param(2, Inject(TuiFocusVisibleService))
], TuiLinkComponent);

let TuiLinkModule = class TuiLinkModule {
};
TuiLinkModule.ɵfac = function TuiLinkModule_Factory(t) { return new (t || TuiLinkModule)(); };
TuiLinkModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TuiLinkModule });
TuiLinkModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, TuiSvgModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiLinkComponent, [{
        type: Component,
        args: [{
                selector: 'a[tuiLink], button[tuiLink]',
                template: "<tui-svg\n    *ngIf=\"iconAlignLeft\"\n    class=\"t-icon t-icon_left\"\n    [src]=\"icon || ''\"\n></tui-svg>\n<span class=\"t-content\">\n    <ng-content></ng-content>\n</span>\n<tui-svg\n    *ngIf=\"iconAlignRight\"\n    class=\"t-icon t-icon_right\"\n    [src]=\"icon || ''\"\n></tui-svg>\n",
                providers: [
                    {
                        provide: TUI_FOCUSABLE_ITEM_ACCESSOR,
                        useExisting: forwardRef(() => TuiLinkComponent_1)
                    },
                    TuiFocusVisibleService,
                    TuiDestroyService,
                    MODE_PROVIDER,
                ],
                changeDetection: ChangeDetectionStrategy.OnPush,
                exportAs: 'tuiLink',
                host: {
                    '($.data-mode.attr)': 'mode$'
                },
                styles: [":host{-webkit-appearance:none;-moz-appearance:none;appearance:none;padding:0;border:0;background:0 0;font-size:inherit;line-height:inherit;transition-property:color;transition-duration:var(--tui-duration,300ms);transition-timing-function:ease-in-out;color:var(--tui-link);text-decoration:none;text-align:left;text-transform:inherit;font-weight:inherit;cursor:pointer;outline:0}:host:hover{color:var(--tui-link-hover)}:host:disabled{opacity:var(--tui-disabled-opacity);cursor:default}:host[data-mode=onLight]{color:var(--tui-text-02)}:host[data-mode=onLight]._active,:host[data-mode=onLight]:hover{color:var(--tui-text-01)}:host[data-mode=onLight]._pseudo{color:var(--tui-text-01)}:host[data-mode=onLight]._pseudo._active,:host[data-mode=onLight]._pseudo:hover{color:var(--tui-text-03)}:host[data-mode=onLight][data-host-mode=negative]{color:var(--tui-negative-night)}:host[data-mode=onLight][data-host-mode=negative]._active,:host[data-mode=onLight][data-host-mode=negative]:active,:host[data-mode=onLight][data-host-mode=negative]:hover{color:var(--tui-negative-night-hover)}:host[data-mode=onDark]{color:var(--tui-text-03-night)}:host[data-mode=onDark]._active,:host[data-mode=onDark]:active,:host[data-mode=onDark]:hover{color:var(--tui-text-01-night)}:host[data-mode=onDark]._pseudo{color:var(--tui-text-01-night)}:host[data-mode=onDark]._pseudo._active,:host[data-mode=onDark]._pseudo:active,:host[data-mode=onDark]._pseudo:hover{color:var(--tui-text-03-night)}:host[data-mode=onDark][data-host-mode=positive]{color:var(--tui-positive-night)}:host[data-mode=onDark][data-host-mode=positive]._active,:host[data-mode=onDark][data-host-mode=positive]:active,:host[data-mode=onDark][data-host-mode=positive]:hover{color:var(--tui-positive-night-hover)}:host[data-host-mode=negative]{color:var(--tui-negative)}:host[data-host-mode=negative]:hover{color:var(--tui-negative-hover)}:host[data-host-mode=positive]{color:var(--tui-positive)}:host[data-host-mode=positive]:hover{color:var(--tui-positive-hover)}.t-content{display:inline-block}:host._focus-visible .t-content{background:var(--tui-selection)}:host[data-mode=onLight]._focus-visible .t-content{background:var(--tui-clear);color:var(--tui-text-01)}:host[data-mode=onDark]._focus-visible .t-content{background:var(--tui-clear-inverse);color:var(--tui-text-01-night)}:host[data-host-mode=positive]._focus-visible .t-content{background:var(--tui-success-bg)}:host[data-host-mode=negative]._focus-visible .t-content{background:var(--tui-error-bg)}:host._pseudo .t-content{padding-bottom:.15em;-webkit-text-decoration:underline dashed;text-decoration:underline dashed;text-underline-offset:.2em;text-decoration-thickness:.7px}.t-icon{transition-property:transform;transition-duration:var(--tui-duration,300ms);transition-timing-function:ease-in-out;margin-top:-.125rem;opacity:.8}.t-icon_left{margin-right:.25rem}.t-icon_right{margin-left:.25rem}:host:hover .t-icon{opacity:1}:host._icon-rotated .t-icon{transform:rotate(180deg)}"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef, decorators: [{
                type: Inject,
                args: [ElementRef]
            }] }, { type: ɵngcc3.Observable, decorators: [{
                type: Inject,
                args: [TUI_MODE]
            }] }, { type: ɵngcc4.TuiFocusVisibleService, decorators: [{
                type: Inject,
                args: [TuiFocusVisibleService]
            }] }]; }, { pseudo: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['class._pseudo']
        }], icon: [{
            type: Input
        }], iconAlign: [{
            type: Input
        }], iconRotated: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['class._icon-rotated']
        }], mode: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.data-host-mode']
        }], focusVisible: [{
            type: HostBinding,
            args: ['class._focus-visible']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiLinkModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, TuiSvgModule],
                declarations: [TuiLinkComponent],
                exports: [TuiLinkComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TuiLinkModule, { declarations: function () { return [TuiLinkComponent]; }, imports: function () { return [CommonModule, TuiSvgModule]; }, exports: function () { return [TuiLinkComponent]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { TuiLinkComponent, TuiLinkModule };

